import { ClubImportGateDialog } from "@/components/features/ClubImport/ClubImportGateDialog";
import { ClubImportNudgeDialog } from "@/components/features/ClubImport/ClubImportNudgeDialog";
import { ExtensionUpdateDialog } from "@/components/features/ClubImport/ExtensionUpdateDialog";
import { CreditsIntroDialog } from "@/components/features/Credits/CreditsIntroDialog";
import { OutOfCreditsDialog } from "@/components/features/Credits/OutOfCreditsDialog";
import { ExtensionReviewDialog } from "@/components/features/ExtensionReview/ExtensionReviewDialog";
import { ClubImportOverlay } from "@/features/MyClub/ClubImportOverlay";
import { EmptyClubDialog } from "@/features/MyClub/EmptyClub/EmptyClubDialog";
import {
  DialogType,
  dialogSelector,
  hideDialog,
} from "@/redux/message/messageSlice";
import { AppDispatch } from "@/redux/store";
import { useDispatch, useSelector } from "react-redux";

import { BaseModalV2 } from "./BaseModalV2";
import { PremiumSubscriptionModal } from "./SpecificModals/PremiumSubscriptionModal";

type ModalV2ConfigEntry = {
  component: React.ComponentType<{
    data?: any;
    onClose: () => void;
  }>;
};

const MODAL_V2_CONFIGS: Record<DialogType, ModalV2ConfigEntry> = {
  "premium-subscription": {
    component: PremiumSubscriptionModal,
  },
  "club-import-gate": {
    component: ClubImportGateDialog,
  },
  "club-import-nudge": {
    component: ClubImportNudgeDialog,
  },
  "out-of-credits": {
    component: OutOfCreditsDialog,
  },
  "credits-intro": {
    component: CreditsIntroDialog,
  },
  "empty-club": {
    component: EmptyClubDialog,
  },
  "now-importing": {
    component: ClubImportOverlay,
  },
  "extension-update-notice": {
    component: ExtensionUpdateDialog,
  },
  "extension-review": {
    component: ExtensionReviewDialog,
  },
};

export const ModalControllerV2 = () => {
  const dispatch = useDispatch<AppDispatch>();
  const modalConfig = useSelector(dialogSelector);

  if (!modalConfig) return null;

  const config = MODAL_V2_CONFIGS[modalConfig.modalType];
  if (!config) return null;

  const handleClose = () => {
    dispatch(hideDialog());
  };

  const ModalComponent = config.component;

  return <ModalComponent data={modalConfig.data} onClose={handleClose} />;
};

// Re-export BaseModalV2 for use in specific modal components
export { BaseModalV2 };
